import React from "react";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink } from "react-router-dom";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import SettingsIcon from '@material-ui/icons/settings';
import sidebarStyle from "../../assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

var ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
  // componentDidMount() {
  //   if (navigator.platform.indexOf("Win") > -1) {
  //     ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
  //       suppressScrollX: true,
  //       suppressScrollY: false
  //     });
  //   }
  // }
  // componentWillUnmount() {
  //   if (navigator.platform.indexOf("Win") > -1) {
  //     ps.destroy();
  //   }
  // }
  render() {
    const { className, headerLinks, links } = this.props;
    return (
      <div className={className}>
        {headerLinks}
        {links}
      </div>
    );
  }
}

function SettingPanel(props) {
  const { className, links, settingFooter } = props;
  return (
    <div className={className}>
      {links}
      {settingFooter}
    </div>
  );
}

class Sidebar extends React.Component {
  componentDidMount() {
    this.setState({ miniActive: this.props.miniActive })
  }

  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openComponents: this.activeRoute("/components"),
      openForms: this.activeRoute("/forms"),
      openTables: this.activeRoute("/tables"),
      openMaps: this.activeRoute("/maps"),
      openPages: this.activeRoute("-page"),
      openPriceMaintenance: this.activeRoute("/priceMaintenance"),
      miniActive: false,
      settingsOpen: false
    };
    this.activeRoute.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }

  toggleSettingsDrawer = (open) => {
    this.setState({ settingsOpen: open });
  }

  render() {
    const {
      classes,
      color,
      logo,
      image,
      logoText,
      routes,
      settingsRoutes,
      bgColor,
      rtlActive,
      className,
      settingFooter,
      showSettings
    } = this.props;

    const links = (<List className={classes.list}>
      {routes.map((prop, key) => {
        if (prop.redirect) {
          return null;
        }
        if (prop.divider) {
          return (<Divider className={classes.itemDivider} />);
        }
        if (prop.collapse) {
          const navLinkClasses =
            classes.itemLink +
            " " +
            cx({
              [" " + classes.collapseActive]: this.activeRoute(prop.path)
            });
          const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]:
                this.props.miniActive && this.state.miniActive,
              [classes.itemTextMiniRTL]:
                rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.itemTextRTL]: rtlActive
            });
          const collapseItemText =
            classes.collapseItemText +
            " " +
            cx({
              [classes.collapseItemTextMini]:
                this.props.miniActive && this.state.miniActive,
              [classes.collapseItemTextMiniRTL]:
                rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.collapseItemTextRTL]: rtlActive
            });
          const itemIcon =
            classes.itemIcon +
            " " +
            cx({
              [classes.itemIconRTL]: rtlActive
            });
          const caret =
            classes.caret +
            " " +
            cx({
              [classes.caretRTL]: rtlActive
            });
          return (
            <ListItem key={key} className={classes.item}>
              <NavLink
                to={"#"}
                className={navLinkClasses}
                onClick={() => this.openCollapse(prop.state)}
              >
                <ListItemIcon className={itemIcon}>
                  {typeof prop.icon === "string" ? (
                    <Icon>{prop.icon}</Icon>
                  ) : (
                      <prop.icon />
                    )}
                </ListItemIcon>
                <ListItemText
                  primary={prop.name}
                  secondary={
                    <b
                      className={
                        caret +
                        " " +
                        (this.state[prop.state] ? classes.caretActive : "")
                      }
                    />
                  }
                  disableTypography={true}
                  className={itemText}
                />
              </NavLink>
              <Collapse in={this.state[prop.state]} unmountOnExit>
                <List className={classes.list + " " + classes.collapseList}>
                  {prop.views.map((prop, key) => {
                    if (prop.redirect) {
                      return null;
                    }
                    const navLinkClasses =
                      classes.collapseItemLink +
                      " " +
                      cx({
                        [" " + classes[color]]: this.activeRoute(prop.path)
                      });
                    const collapseItemMini =
                      classes.collapseItemMini +
                      " " +
                      cx({
                        [classes.collapseItemMiniRTL]: rtlActive
                      });
                    return (
                      <ListItem key={key} className={classes.collapseItem}>
                        <NavLink to={prop.path} className={navLinkClasses}>
                          <span className={collapseItemMini}>
                            {prop.mini}
                          </span>
                          <ListItemText
                            primary={prop.name}
                            disableTypography={true}
                            className={collapseItemText}
                          />
                        </NavLink>
                      </ListItem>
                    );
                  })}
                </List>
              </Collapse>
            </ListItem>
          );
        }
        const navLinkClasses =
          classes.itemLink +
          " " +
          cx({
            [" " + classes[color]]: this.activeRoute(prop.path)
          });
        const itemText =
          classes.itemText +
          " " +
          cx({
            [classes.itemTextMini]:
              this.props.miniActive && this.state.miniActive,
            [classes.itemTextMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
            [classes.itemTextRTL]: rtlActive
          });
        const itemIcon =
          classes.itemIcon +
          " " +
          cx({
            [classes.itemIconRTL]: rtlActive
          });
        return (
          <ListItem key={key} className={classes.item}>
            <NavLink to={prop.path} className={navLinkClasses}>
              <ListItemIcon className={itemIcon}>
                {typeof prop.icon === "string" ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                    <prop.icon />
                  )}
              </ListItemIcon>
              <ListItemText
                primary={prop.name}
                disableTypography={true}
                className={itemText}
              />
            </NavLink>
          </ListItem>
        );
      })}

      {
        showSettings &&
        <ListItem key='settings-tab' className={classes.settingItem}>
          <div onClick={() => this.toggleSettingsDrawer(true)} className={classes.itemLink}>
            <ListItemIcon className={classes.itemIcon}>
              <SettingsIcon className={classes.settingIcon} />
            </ListItemIcon>
            <ListItemText
              primary={"Settings"}
              disableTypography={true}
              className={classes.itemText +
                " " +
                cx({
                  [classes.itemTextMini]:
                    this.props.miniActive && this.state.miniActive,
                  [classes.itemTextMiniRTL]:
                    rtlActive && this.props.miniActive && this.state.miniActive,
                  [classes.itemTextRTL]: rtlActive
                })}
            />
          </div>
        </ListItem>
      }
    </List>);

    const settingsDrawerLinks = GenerateSettingLinksFromRoutes(settingsRoutes, classes);

    const logoNormal =
      classes.logoNormal +
      " " +
      cx({
        [classes.logoNormalSidebarMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.logoNormalSidebarMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.logoNormalRTL]: rtlActive
      });
    const logoMini =
      classes.logoMini +
      " " +
      cx({
        [classes.logoMiniRTL]: rtlActive
      });
    const logoClasses =
      classes.logo +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white"
      });
    var brand = (
      <div className={logoClasses}>
        <a href="/" className={logoMini}>
          {typeof logo === "string"
            ? (<img src={logo} alt="logo" className={classes.img} />)
            : <span>{logo}</span>
          }
        </a>
        <a href="/" className={logoNormal}>
          {logoText}
        </a>
      </div>
    );
    const drawerPaper =
      classes.drawerPaper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.drawerPaperRTL]: false
      });
    const sidebarWrapper =
      classes.sidebarWrapper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });

    const rightSidebarWrapper =
      classes.rightSidebarWrapper +
      " " +
      cx({
        [classes.drawerPaperMini]: false,
        [classes.sidebarWrapperWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1
      });

    // ref="mainPanel" the main sidebar
    return (
      <div className={className || ''}>

        {/* Renders when the hamburger is clicked - mobile view*/}
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={"left"}
            open={this.props.open}
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"] + " " + "mobile-sidebar"
            }}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>

        {/* default render */}
        <Hidden smDown implementation="css">
          <Drawer
            onMouseOver={() => this.setState({ miniActive: false })}
            onMouseOut={() => this.setState({ miniActive: true })}
            anchor={"left"}
            variant="permanent"
            open
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"] + " " + "default-sidebar"
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>

        {/* right setting bar */}
        {
          showSettings &&
          <Drawer
            anchor={"right"}
            variant="temporary"
            open={this.state.settingsOpen}
            onBackdropClick={() => this.toggleSettingsDrawer(false)}
          >
            <SettingPanel
              className={rightSidebarWrapper}
              links={settingsDrawerLinks}
              settingFooter={settingFooter}
            />
          </Drawer>
        }
      </div>
    );
  }
}

const GenerateSettingLinksFromRoutes = (routes, classes) => {
  if (!routes || routes.length === 0) { return null; }
  return (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        if (prop.redirect) {
          return null;
        }
        if (prop.collapse) {
          const navLinkClasses = classes.itemLink;
          const itemText = classes.itemText;
          const collapseItemText = classes.collapseItemText;
          const itemIcon = classes.itemIcon;
          const caret = classes.caret;

          return (
            <ListItem key={key} className={classes.item}>
              <NavLink
                to={"#"}
                className={navLinkClasses}
                onClick={() => this.openCollapse(prop.state)}
              >
                <ListItemIcon className={itemIcon}>
                  {typeof prop.icon === "string" ? (
                    <Icon>{prop.icon}</Icon>
                  ) : (
                      <prop.icon />
                    )}
                </ListItemIcon>
                <ListItemText
                  primary={prop.name}
                  secondary={
                    <b
                      className={
                        caret +
                        " " +
                        (this.state[prop.state] ? classes.caretActive : "")
                      }
                    />
                  }
                  disableTypography={true}
                  className={itemText}
                />
              </NavLink>
              <Collapse in={this.state[prop.state]} unmountOnExit>
                <List className={classes.list + " " + classes.collapseList}>
                  {prop.views.map((prop, key) => {
                    if (prop.redirect) {
                      return null;
                    }
                    const navLinkClasses =
                      classes.collapseItemLink;
                    const collapseItemMini =
                      classes.collapseItemMini;
                    return (
                      <ListItem key={key} className={classes.collapseItem}>
                        <NavLink to={prop.path} className={navLinkClasses}>
                          <span className={collapseItemMini}>
                            {prop.mini}
                          </span>
                          <ListItemText
                            primary={prop.name}
                            disableTypography={true}
                            className={collapseItemText}
                          />
                        </NavLink>
                      </ListItem>
                    );
                  })}
                </List>
              </Collapse>
            </ListItem>
          );
        }
        const navLinkClasses = classes.itemLink;
        const itemText = classes.itemText;
        const itemIcon = classes.itemIcon;
        return (
          <ListItem key={key} className={classes.item}>
            <NavLink to={prop.path} className={navLinkClasses}>
              <ListItemIcon className={itemIcon}>
                {typeof prop.icon === "string" ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                    <prop.icon />
                  )}
              </ListItemIcon>
              <ListItemText
                primary={prop.name}
                disableTypography={true}
                className={itemText}
              />
            </NavLink>
          </ListItem>
        );
      })}
    </List>
  );
}

Sidebar.defaultProps = {
  bgColor: "blue"
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose"
  ]),
  showSettings: PropTypes.bool,
  logo: PropTypes.any,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  settingsRoutes: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string
};

SettingPanel.propTypes = {
  className: PropTypes.string,
  settingFooter: PropTypes.element
}

export default withStyles(sidebarStyle)(Sidebar);
